import React from 'react';
import { CVSheet } from '../components/cv/CVSheet';
import { ScaledSheet } from '../components/cv/ScaledSheet';
/**
 * The print-ready A4 CV surface (body only). Renders the single condensed CV
 * layout; the Export button lives in the App header.
 */
export function CvView() {
  return <div className="cv-view w-full bg-[#efe9e0]" data-id="element-340" data-mp="3ole72chysyan">
      <div className="print-stage flex flex-col items-center px-3 pb-8 pt-6 sm:px-4" data-id="element-341" data-mp="3ojtf8un1btgh">
        <ScaledSheet data-id="element-342" data-mp="65u0q9a0pvzu">
          <CVSheet compact data-id="element-343" data-mp="6981xe6y3z5p" />
        </ScaledSheet>
      </div>
    </div>;
}